module.exports = __webpack_public_path__ + "static/media/lamina19texto.64c0e244.png";